export const formatExpiry = (isoDate: string): string => {
  const date = new Date(isoDate);
  const day = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const time = date
    .toLocaleTimeString('en-US', { hour: 'numeric', timeZoneName: 'shortGeneric' })
    .replace(' ', '');
  return `${day} ${time}`;
};
